module.exports = __webpack_public_path__ + "assets/on-low-battery.f8c5a425.svg";